import React from 'react'
import { LinearGradient } from 'expo-linear-gradient'
import { styled, useDripsyTheme } from 'dripsy'
type Props = React.ComponentProps<typeof LinearGradient>

const Grad = styled(
  React.memo(
    function Gradient(props: Props) {
      const { colors } = useDripsyTheme().theme
      return (
        <LinearGradient
          {...props}
          colors={props.colors?.map(
            (color) => (colors?.[color] as string) ?? color
          )}
        />
      )
    },
    (prev, next) => JSON.stringify(prev) === JSON.stringify(next)
  )
)({})

export default function Gradient(props: React.ComponentProps<typeof Grad>) {
  return <Grad {...props} />
}
